import React, { useState } from "react";
import { Modal, Btn, Field, Input } from "@/components/erp/ui";
import { Printer } from "lucide-react";
import { API_BASE } from "@/lib/api";

const PRESETS = [[33, 15], [40, 30], [50, 25], [50, 30], [60, 40], [70, 50], [100, 50], [100, 100]];

// Cetak label QR spool: ukuran kertas bebas, tiap unit 2x (kotak + dalam spool)
export const PoLabelModal = ({ spools, onClose }) => {
  const [size, setSize] = useState({ w: 50, h: 30 });
  const [copies, setCopies] = useState(2);
  const print = () => window.open(`${API_BASE}/spools/stickers.pdf?ids=${spools.map((s) => s.id).join(",")}&w=${size.w}&h=${size.h}&copies=${copies}`, "_blank");
  return (
    <Modal open={!!spools?.length} onClose={onClose} title={`Cetak Label QR · ${spools?.length || 0} unit`}
      footer={<><Btn variant="ghost" onClick={onClose}>Nanti</Btn><Btn data-testid="label-print" onClick={print}><Printer className="w-4 h-4" /> Cetak {(spools?.length || 0) * copies} label</Btn></>}>
      <p className="text-sm text-slate-600 mb-3">Spool baru siap diberi label. Label QR berisi kode spool + tanggal & jam masuk, semua rata tengah. Bisa dicek pakai kamera HP (tombol Scan).</p>
      <div className="text-xs text-slate-500 mb-1">Ukuran kertas stiker (mm)</div>
      <div className="flex flex-wrap gap-2 mb-3" data-testid="label-presets">
        {PRESETS.map(([w, h]) => <button key={`${w}x${h}`} type="button" data-testid={`label-size-${w}x${h}`} onClick={() => setSize({ w, h })}
          className={`px-3 py-1 rounded-full border text-sm ${size.w === w && size.h === h ? "bg-slate-900 text-white border-slate-900" : "border-slate-200"}`}>{w}×{h}</button>)}
      </div>
      <div className="grid grid-cols-3 gap-3">
        <Field label="Lebar (mm)"><Input type="number" data-testid="label-w" value={size.w} onChange={(e) => setSize({ ...size, w: +e.target.value })} /></Field>
        <Field label="Tinggi (mm)"><Input type="number" data-testid="label-h" value={size.h} onChange={(e) => setSize({ ...size, h: +e.target.value })} /></Field>
        <Field label="Cetak per unit"><Input type="number" data-testid="label-copies" value={copies} onChange={(e) => setCopies(Math.min(4, Math.max(1, +e.target.value)))} /></Field>
      </div>
      <p className="text-[11px] text-slate-500 mt-2">Default 2 per unit: 1 ditempel di kotak, 1 di dalam spool.</p>
      <div className="mt-3 text-xs font-mono text-slate-500 max-h-24 overflow-y-auto">{spools?.map((s) => s.code).join(" · ")}</div>
    </Modal>
  );
};
